export const business = {
  name: 'Fateh Heating and Cooling',
  phone: '+14379811504',
  phoneDisplay: '437-981-1504',
  email: 'fatehheatingandcooling@gmail.com',
  address: {
    street: '2221 Cardinal Court',
    city: 'London',
    province: 'ON',
    postal: 'N6M 0C2',
    country: 'Canada',
    full: '2221 Cardinal Court, London, ON N6M 0C2',
  },
  hours: 'Open 24 Hours',
  rating: 5.0,
  reviewCount: 16,
  serviceAreas: ['London', 'St. Thomas', 'Strathroy', 'Woodstock'],
  // Update this with the real Google Business Profile URL after going live
  googleBusinessUrl: 'https://www.google.com/search?q=Fateh+Heating+and+Cooling+London+Ontario',

  services: [
    {
      id: 'installation',
      title: 'Installation',
      subtitle: 'New equipment, done right.',
      description:
        'Full installation of furnaces, central air conditioners, and heat pumps for residential properties. New builds and complete system replacements — we size and install it properly.',
      tags: ['Furnaces', 'Air Conditioners', 'Heat Pumps', 'System Replacements'],
    },
    {
      id: 'repair',
      title: 'Repair & Maintenance',
      subtitle: 'Fast diagnostics, reliable fixes.',
      description:
        'Heating or cooling system acting up? We diagnose and repair all makes and models. Seasonal tune-ups keep your equipment running efficiently and extend its lifespan.',
      tags: ['Diagnostics & Repair', 'Seasonal Tune-Ups', 'Preventive Maintenance'],
    },
  ],

  trustSignals: [
    {
      label: '5.0 Google Rating',
      detail: '16 five-star reviews',
      icon: 'Star',
    },
    {
      label: 'TSSA Authorized',
      detail: 'Licensed by the Technical Standards & Safety Authority',
      icon: 'BadgeCheck',
    },
    {
      label: 'G2 Licensed',
      detail: 'ODP Certified technicians',
      icon: 'ShieldCheck',
    },
    {
      label: 'Open 24 Hours',
      detail: "We're here when you need us",
      icon: 'Clock',
    },
    {
      label: 'Locally Owned',
      detail: 'Small team, personal service',
      icon: 'Users',
    },
    {
      label: 'London & Area',
      detail: 'Serving 4 communities',
      icon: 'MapPin',
    },
  ],

  // PLACEHOLDER — replace with actual customer reviews before going live
  reviews: [
    {
      name: 'Michael T.',
      location: 'London, ON',
      text: 'Had our old furnace replaced by Fateh last winter. They were professional, fast, and cleaned up after themselves. New unit runs perfectly — highly recommend.',
      rating: 5,
    },
    {
      name: 'Sarah K.',
      location: 'St. Thomas, ON',
      text: 'Our AC went down during a heat wave and they came out same day. Fixed it quickly and the price was fair. Will definitely call them again.',
      rating: 5,
    },
    {
      name: 'David R.',
      location: 'London, ON',
      text: 'Got a full heat pump installation done. The team explained everything, handled all the details, and the system has been running great ever since. Five stars.',
      rating: 5,
    },
  ],
}
